import { Route, Routes } from "react-router-dom";
import HomePage from "./pages/HomePage";
import AboutPage from "./pages/AboutPage";
import ProjectsPage from "./pages/ProjectsPage";
import PublicationsPage from "./pages/PublicationsPage";
// import RegistrationPage from "./pages/Registration";
import GalleryPage from "./pages/GalleryPage";
import EventNewsPage from "./pages/EventPage";
import ContactPage from "./pages/ContactPage";
// import OurWorkPage from "./pages/OurWorkPage";
import UnderConstruction from "./components/UnderConstruction";
import Admin from "./components/Admin/Admin";
import AdminDashboard from "./components/Admin/Dashboard/AdminDashboard/AdminDashboard";
import Login from "./components/Admin/Administration/Login";
import SignUp from "./components/Admin/Administration/SignUp";
import ProtectedRoute, { PublicRoute } from "./Utils/ProtectRoutes";
import Aboutus from "./components/Admin/Dashboard/Aboutus/Aboutus";
import Project from "./components/Admin/Dashboard/Project/Project";
import Publication from "./components/Admin/Dashboard/Publication/publication";
import Registration from "./components/User/Register/register";
import ProjectDetails from "./components/User/ProjectDetails/ProjectDetails";
import GalleryManager from "./components/Admin/Dashboard/GalleryManager/GalleryManager";
import NewsManager from "./components/Admin/Dashboard/NewsManager/NewsManager";
import ContactManager from "./components/Admin/Dashboard/ContactManager/ContactManager";
import BannerManager from "./components/Admin/Dashboard/BannerManager/BannerManager";
import EventList from "./components/Admin/Dashboard/Events/EventList";
import EventForm from "./components/Admin/Dashboard/Events/EventForm";
import Evidence from "./components/Admin/Dashboard/Events/Evidence";
import Participant from "./components/Admin/Dashboard/Events/Participant";
import Users from "./components/Admin/Dashboard/users/user";
import EventDetails from "./components/User/EventNews/EventDetails";
import AdminUserControl from "./components/Admin/Administration/adminUserControl";
import Settings from "./components/User/Setting/menu";
import ForgetPassword from "./components/Admin/Administration/forgetpassword";


const RouteComponent = () => {
  return (
    <Routes>
      <Route path="/" element={<HomePage />} />
      <Route path="/about" element={<AboutPage />} />
      <Route path="/projects" element={<ProjectsPage />} />
      <Route path="/project-details/:id" element={<ProjectDetails />} />
      <Route path="/publications" element={<PublicationsPage />} />
      <Route path="/gallery" element={<GalleryPage />} />
      <Route path="/contact" element={<ContactPage />} />
      <Route path="/events" element={<EventNewsPage />} />
      <Route path="/eventdetails/:id" element={<EventDetails />} />
      {/* <Route path="/our-work" element={<OurWorkPage />} />*/}
      <Route path="/admin" element={<Admin />}>
        <Route element={<ProtectedRoute />}>
          <Route path="dashboard" element={<AdminDashboard />} />
          <Route path="banners" element={<BannerManager />} />
          <Route path="aboutus" element={<Aboutus />} />
          <Route path="project" element={<Project />} />
          <Route path="publication" element={<Publication />} />
          <Route path="gallery" element={<GalleryManager />} />
          <Route path="news" element={<NewsManager />} />
          <Route path="contactus" element={<ContactManager />} />
          <Route path="eventlist" element={<EventList />} />
          <Route path="addEvents/:id" element={<EventForm />} />
          <Route path="events/:id/evidence" element={<Evidence />} />
          <Route path="events/:id/participants" element={<Participant />} />
          <Route path="userlist" element={<Users />} />
          <Route path="setting" element={<Settings />} />
          <Route path="registration" element={<SignUp />} />
          <Route path="admin-control" element={<AdminUserControl />} />
          <Route path="forgotPassword" element={<ForgetPassword />} />
        </Route>
        <Route element={<PublicRoute />}>
          <Route path="administrator" element={<Login />} />
        </Route>
      </Route>
      <Route path="*" element={<UnderConstruction />} />
    </Routes>
  )
}

export default RouteComponent;